module.exports = __webpack_public_path__ + "img/5f19007.jpg";